export const getModalType = (state) => state.modal.type
export const getModalData = (state) => state.modal.data
